/** Helpers de prazo, atraso e textos — tela Fila (API mobileNovo1). */

export function normalizarPrazoFila(vaga) {
	const p = vaga?.prazoFila
	if (!p || typeof p !== "object") return {}
	return p
}

export function resolverMotivoTipo(vaga) {
	return String(vaga?.motivoTipo || "ok")
}

export function isMotivoProximidade(vaga) {
	const t = resolverMotivoTipo(vaga)
	return t === "fora_raio" || t === "sem_geo"
}

/** Ex.: "300 m", "1,2 km" */
export function formatarMetrosCurto(metros) {
	const m = Number(metros)
	if (!Number.isFinite(m) || m <= 0) return ""
	if (m < 1000) return `${Math.max(1, Math.round(m))} m`
	const km = m / 1000
	if (km < 10) {
		const txt = km.toFixed(1).replace(".", ",").replace(/,0$/, "")
		return `${txt} km`
	}
	return `${Math.round(km)} km`
}

/** Distância atual até a vaga (API ou metros numéricos). */
export function textoDistanciaVagaFila(vaga) {
	let t = String(vaga?.distanciaTexto || "").trim()
	if (t.includes(" · Raio da fila:")) {
		t = t.split(" · Raio da fila:")[0].trim()
	}
	if (t) return t
	const m = Number(vaga?.distanciaMetros)
	if (Number.isFinite(m) && m > 0) {
		return `Aproximadamente ${formatarMetrosCurto(m)} de você`
	}
	return ""
}

/** Limite configurado no painel (raio de entrada na fila). */
export function textoLimiteRaioFila(vaga) {
	const raio = Number(vaga?.raioFilaMetros)
	if (!Number.isFinite(raio) || raio <= 0) return ""
	return `Limite para entrar na fila: ${formatarMetrosCurto(raio)}.`
}

export function extrairHoraDeTexto(texto) {
	const m = String(texto || "").match(/(\d{1,2}):(\d{2})/)
	if (!m) return ""
	const h = m[1].padStart(2, "0")
	return `${h}:${m[2]}`
}

/** Hora em que a fila abre hoje (para chips e mensagens curtas). */
export function horaAbreFila(vaga) {
	const prazo = normalizarPrazoFila(vaga)
	const daJanela = extrairHoraDeTexto(vaga?.janelaEntrada?.abreEm)
	if (daJanela) return daJanela
	if (prazo.inicioJornadaHora) return prazo.inicioJornadaHora
	return extrairHoraDeTexto(vaga?.motivo)
}

export function exibirPrazoFilaHoje(vaga) {
	if (!vaga?.jornadaHoje) return false
	const p = normalizarPrazoFila(vaga)
	if (p.exibir === false) return false
	return Boolean(p.ingressoAteHora || p.inicioJornadaHora)
}

/** Uma linha com o essencial: até quando pode entrar. */
export function textoLimiteEntradaFila(prazo) {
	const ate = String(prazo?.ingressoAteHora || "").trim()
	if (!ate) return ""
	if (prazo?.reentrada) {
		return `Reentrada até ${ate}`
	}
	const ini = String(prazo?.inicioJornadaHora || prazo?.horaInicio || "").trim()
	if (ate !== ini) {
		return `Entrada até ${ate}`
	}
	return `Entrada às ${ate}`
}

export function textoMinutosRestantes(prazo) {
	if (prazo?.prazoEncerrado || prazo?.jornadaEncerrada) return ""
	const m = prazo?.minutosRestantes
	if (m == null) return ""
	if (m <= 0) return "Últimos minutos"
	if (m < 60) return `${m} min restantes`
	const h = Math.floor(m / 60)
	const r = m % 60
	return r > 0 ? `${h}h ${r}min restantes` : `${h}h restantes`
}

export function estaAtrasadoParaFila(vaga) {
	return Boolean(normalizarPrazoFila(vaga).estaAtrasado)
}

/** Mensagem curta para alertas (API pode vir longa). */
export function simplificarMotivoFila(vaga) {
	const tipo = resolverMotivoTipo(vaga)
	const motivo = String(vaga?.motivo || "").trim()
	const prazo = normalizarPrazoFila(vaga)
	const ate = String(prazo?.ingressoAteHora || "").trim()

	if (tipo === "aguardando") {
		const abre = horaAbreFila(vaga)
		return abre ? `Abre às ${abre}.` : "Aguarde o horário."
	}
	if (tipo === "prazo_encerrado") {
		return "Prazo da primeira entrada encerrado."
	}
	if (tipo === "jornada_encerrada" || prazo.jornadaEncerrada) {
		return "Jornada encerrada hoje."
	}
	if (tipo === "em_servico") {
		return "Termine o serviço para voltar à fila."
	}
	if (tipo === "reentrada_fila" || prazo.reentrada) {
		return ate ? `Pode voltar à fila até ${ate}.` : "Pode voltar à fila hoje."
	}
	if (tipo === "sem_jornada" || !vaga?.jornadaHoje) {
		return "Sem escala hoje."
	}
	if (tipo === "na_fila") {
		return "Você já está na fila."
	}
	if (estaAtrasadoParaFila(vaga) && ate) {
		return `Entre até ${ate}.`
	}
	if (/abre em|abre às|início da jornada/i.test(motivo)) {
		const h = extrairHoraDeTexto(motivo)
		return h ? `Abre às ${h}.` : "Aguarde o horário."
	}
	if (/jornada.*encerrou/i.test(motivo)) {
		return "Jornada encerrada hoje."
	}
	if (/primeira entrada|encerrou|encerrado|tolerância 0/i.test(motivo)) {
		return "Prazo da primeira entrada encerrado."
	}
	if (motivo.length > 100) {
		return `${motivo.slice(0, 97)}…`
	}
	return motivo
}

export function temSituacaoFilaHoje(vaga) {
	if (!vaga?.jornadaHoje) return false
	if (vaga.naFila || vaga.podeEntrarFila || vaga.podeSairFila) return true
	if (estaAtrasadoParaFila(vaga)) return true
	const t = resolverMotivoTipo(vaga)
	return [
		"fora_raio",
		"sem_geo",
		"aguardando",
		"prazo_encerrado",
		"jornada_encerrada",
		"em_servico",
		"reentrada_fila",
		"atrasado",
	].includes(t)
}

/**
 * Chip de status no card.
 * @returns {{ label: string, variant: 'ok'|'warn'|'brand'|'muted'|'danger' }}
 */
export function resolverChipStatusFila(vaga) {
	if (!vaga) return { label: "Vaga", variant: "muted" }
	if (vaga.naFila) return { label: "Na fila", variant: "ok" }

	const prazo = normalizarPrazoFila(vaga)
	const tipo = resolverMotivoTipo(vaga)
	const atrasado = estaAtrasadoParaFila(vaga)

	if (tipo === "prazo_encerrado" || (prazo.prazoEncerrado && !prazo.jaEntrouHoje)) {
		return { label: "Prazo passou", variant: "muted" }
	}
	if (tipo === "jornada_encerrada" || prazo.jornadaEncerrada) {
		return { label: "Jornada fim", variant: "muted" }
	}
	if (tipo === "em_servico" || vaga.temServicoAtivo) {
		return { label: "Em serviço", variant: "warn" }
	}

	if (atrasado) {
		if (vaga.podeEntrarFila) return { label: "Atrasado", variant: "danger" }
		if (tipo === "fora_raio") return { label: "Atrasado", variant: "danger" }
		if (tipo === "sem_geo") return { label: "Atrasado", variant: "danger" }
		return { label: "Atrasado", variant: "danger" }
	}

	if (vaga.podeEntrarFila) {
		if (tipo === "reentrada_fila" || prazo.reentrada) {
			return { label: "Pode voltar", variant: "brand" }
		}
		return { label: "Pode entrar", variant: "brand" }
	}
	if (vaga.podeSairFila) return { label: "Na fila", variant: "ok" }

	if (tipo === "sem_jornada" || !vaga.jornadaHoje) {
		return { label: "Sem escala", variant: "muted" }
	}
	if (tipo === "fora_raio") {
		if (prazo.reentrada || vaga.jaEntrouFilaHoje) {
			return { label: "Volte ao raio", variant: "warn" }
		}
		return { label: "Vá até a vaga", variant: "warn" }
	}
	if (tipo === "sem_geo") return { label: "Ative o GPS", variant: "warn" }
	if (tipo === "aguardando") {
		const abre = horaAbreFila(vaga)
		return abre ? { label: `Abre ${abre}`, variant: "warn" } : { label: "Aguarde", variant: "warn" }
	}
	if (tipo === "reentrada_fila" || prazo.reentrada) {
		return { label: "Pode voltar", variant: "brand" }
	}

	if (vaga.jornadaHoje) return { label: "Hoje", variant: "brand" }
	return { label: "Sem fila", variant: "muted" }
}

export function mergeEstadoFilaNoDetalhe(detalhe, vagaLista) {
	if (!detalhe || typeof detalhe !== "object") return detalhe
	if (!vagaLista) return detalhe
	return {
		...detalhe,
		prazoFila: vagaLista.prazoFila ?? detalhe.prazoFila,
		motivoTipo: vagaLista.motivoTipo ?? detalhe.motivoTipo,
		motivo: vagaLista.motivo ?? detalhe.motivo,
		podeEntrarFila: vagaLista.podeEntrarFila ?? detalhe.podeEntrarFila,
		podeSairFila: vagaLista.podeSairFila ?? detalhe.podeSairFila,
		naFila: vagaLista.naFila ?? detalhe.naFila,
		posicaoFila: vagaLista.posicaoFila ?? detalhe.posicaoFila,
		totalNaFila: vagaLista.totalNaFila ?? detalhe.totalNaFila,
		entrouEm: vagaLista.entrouEm ?? detalhe.entrouEm,
		jornadaHoje: vagaLista.jornadaHoje ?? detalhe.jornadaHoje,
		horarioHoje: vagaLista.horarioHoje ?? detalhe.horarioHoje,
		diaHoje: vagaLista.diaHoje ?? detalhe.diaHoje,
		dataRefFormatada: vagaLista.dataRefFormatada ?? detalhe.dataRefFormatada,
		dentroRaioFila: detalhe.dentroRaioFila ?? vagaLista.dentroRaioFila,
		distanciaTexto: detalhe.distanciaTexto ?? vagaLista.distanciaTexto,
		distanciaMetros: detalhe.distanciaMetros ?? vagaLista.distanciaMetros,
		raioFilaMetros: detalhe.raioFilaMetros ?? vagaLista.raioFilaMetros,
		janelaEntrada: vagaLista.janelaEntrada ?? detalhe.janelaEntrada,
		jaEntrouFilaHoje: vagaLista.jaEntrouFilaHoje ?? detalhe.jaEntrouFilaHoje,
		temServicoAtivo: vagaLista.temServicoAtivo ?? detalhe.temServicoAtivo,
	}
}
